import axios from "axios";
import home from "../../home/home";
import {calculateTimeDifferenceTwoDates, geDataFormat, logOut} from "../../../common/utils";
import jwt_decode from "jwt-decode";
import TipologiaSanzione from '../../../common/mookup/tipologieSanzioni.json'
export default class dashboardTipologiaSanzioneService{

    // getDataTableArea(onSuccess){
    //   onSuccess(mookAree)
    // }


    getDataTableTipologiaSanzione(onSuccess) {
      var objUser = JSON.parse(sessionStorage.getItem("user"));
      var decoded = jwt_decode(objUser.token);
      let host = process.env.REACT_APP_API_URL;
      const configHeaders = {
        headers: {
          Authorization: "Bearer " + objUser.token,
          CF: decoded.CFA,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Headers":
            "Origin, X-Requested-With, Content-Type, Accept",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        }
      };
     axios.get(host+"/api/v1/tipologiaSanzione/find/", configHeaders).then(function(result){
      if(result.status === 401){
        logOut();
      }
          onSuccess(result.data);
      }, function(error){
       if(error.response.status === 401){
          logOut();
        }
          console.log("Errore di  "+error);
          onSuccess("");
      });
    }
    // getDataTableTipologiaSanzione(onSuccess) {
    //   onSuccess(TipologiaSanzione)
    // }

    deleteTipologia(idLinea,onSuccess) {
      var objUser = JSON.parse(sessionStorage.getItem("user"));
      var decoded = jwt_decode(objUser.token);
      let host = process.env.REACT_APP_API_URL;
      const configHeaders = {
        headers: {
          Authorization: "Bearer " + objUser.token,
          CF: decoded.CFA,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Headers":
            "Origin, X-Requested-With, Content-Type, Accept",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        }
      };
     axios.post(host+"/api/v1/tipologiaSanzione/disabilita/" + idLinea,"", configHeaders).then(function(result){
      if(result.status === 401){
        logOut();
      }
          onSuccess(result);
      }, function(error){
        if(error.response.status === 401){
          logOut();
        }
          console.log("Errore di  "+error);
          onSuccess("");
      });
    }

    salvaModifica(linea,onSuccess) {
      var objUser = JSON.parse(sessionStorage.getItem("user"));
      var decoded = jwt_decode(objUser.token);
      let host = process.env.REACT_APP_API_URL;
      const configHeaders = {
        headers: {
          Authorization: "Bearer " + objUser.token,
          CF: decoded.CFA,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Headers":
            "Origin, X-Requested-With, Content-Type, Accept",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        }
      };
     axios.post(host+"/api/v1/tipologiaSanzione/aggiornaTipologiaSanzione",linea, configHeaders).then(function(result){
      if(result.status === 401){
        logOut();
      }
          onSuccess(result);
      }, function(error){
        if(error.response.status === 401){
          logOut();
        }
          console.log("Errore di  "+error);
          onSuccess("");
      });
    }
    insertTipologia(linea,onSuccess) {
      var objUser = JSON.parse(sessionStorage.getItem("user"));
      var decoded = jwt_decode(objUser.token);
      let host = process.env.REACT_APP_API_URL;
      const configHeaders = {
        headers: {
          Authorization: "Bearer " + objUser.token,
          CF: decoded.CFA,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Headers":
            "Origin, X-Requested-With, Content-Type, Accept",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        }
      };
      linea.idCliente= objUser.idCliente
     axios.post(host+"/api/v1/tipologiaSanzione/inserisciTipologiaSanzione" ,linea, configHeaders).then(function(result){
      if(result.status === 401){
        logOut();
      }
          onSuccess(result);
      }, function(error){
        if(error.response.status === 401){
          logOut();
        }
          console.log("Errore di  "+error);
          onSuccess("");
      });
    }

}
